import React, { useState, useEffect } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { Fieldset, Legend } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";

const jours = {
  lun: "Lundi",
  mar: "Mardi",
  mer: "Mercredi",
  jeu: "Jeudi",
  ven: "Vendredi",
  sam: "Samedi",
};

const PanelNotaireHoraires = () => {
  const context = useNotaire();
  const [horaires, setHoraires] = useState({});
  const [checked, setChecked] = useState({});
  const [recordId, setRecordId] = useState(null);

  const BASE_ID = "appD48APNaGA4GN0B";

  useEffect(() => {
    const horaireId = Array.isArray(context.infoEtude?.horaires)
      ? context.infoEtude.horaires[0]
      : null;
    if (!horaireId) return;

    const fetchHoraires = async () => {
      try {
        const res = await fetch(
          `https://api.airtable.com/v0/${BASE_ID}/horaires/${horaireId}`,
          {
            headers: {
              Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();

        if (!data.id) {
          console.warn("[PanelNotaireHoraires] record introuvable");
          return;
        }

        const fields = data.fields || {};
        setRecordId(data.id);
        setHoraires(fields);

        const checkedMap = {};
        Object.keys(jours).forEach((jour) => {
          const val = fields[jour];
          checkedMap[jour] = val && val.toLowerCase() !== "fermé";
        });

        setChecked(checkedMap);
      } catch (err) {
        console.error("Erreur chargement horaires:", err);
        toast.error("Erreur lors du chargement des horaires");
      }
    };

    fetchHoraires();
  }, [context.infoEtude?.horaires]);

  const handleCheck = (jour) => {
    setChecked((prev) => ({
      ...prev,
      [jour]: !prev[jour],
    }));
  };

  const handleHoraireChange = (jour, value) => {
    setHoraires((prev) => ({
      ...prev,
      [jour]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("recordid",recordId);

    if (!recordId) {
      toast.error("Record horaires introuvable.");
      return;
    }

    const payload = {};
    Object.keys(jours).forEach((jour) => {
      payload[jour] = checked[jour] ? horaires[jour] || "" : "fermé";
    });

    try {
      const res = await fetch(
        `https://api.airtable.com/v0/${BASE_ID}/horaires/${recordId}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fields: payload }),
        }
      );

      if (res.ok) {
        toast.success("Horaires mis à jour !");
      } else {
        const err = await res.text();
        console.error("Airtable error:", err);
        toast.error("Erreur de mise à jour des horaires");
      }
    } catch (err) {
      console.error("Erreur réseau:", err);
      toast.error("Erreur réseau");
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow mt-8">
      <form onSubmit={handleSubmit}>
        <Fieldset>
          <Legend>Horaires d'ouverture</Legend>
          <ul className="divide-y divide-gray-200">
            {Object.entries(jours).map(([jour, label]) => (
              <li className="py-2" key={jour}>
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={checked[jour] || false}
                    onChange={() => handleCheck(jour)}
                  />
                  <span>{label}</span>
                </label>

                {checked[jour] && (
                  <input
                    type="text"
                    value={horaires[jour] || ""}
                    onChange={(e) => handleHoraireChange(jour, e.target.value)}
                    placeholder="Ex: 09:00 - 18:00"
                    className="mt-2 w-full border p-2 rounded"
                  />
                )}
              </li>
            ))}
          </ul>
        </Fieldset>

        <button type="submit" className="btn-primary mt-4">
          Enregistrer les horaires
        </button>
      </form>
    </div>
  );
};

export default PanelNotaireHoraires;
